import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

const apiRequest = async (apiFn, api, errorMessage, data) => {
  try {
    const response = await apiFn(api, data);
    if (response?.success) {
      return response?.data;
    } else {
      throw new Error(response?.message || errorMessage);
    }
  } catch (error) {
    throw new Error(error.message || errorMessage);
  }
};

export const saveQuickQuiz = createAsyncThunk(
  "quickQuiz/save",
  async ({ p_category_id, quiz_data }, { rejectWithValue }) => {
    try {
      const data = await apiRequest(POST, API.SAVE_QUICK_QUIZ, "Quiz save failed", {
        p_category_id,
        quiz_data,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const quickQuizSlice = createSlice({
  name: "quickQuiz",
  initialState: { saving: false, saved: false, error: null },
  reducers: {
    resetQuickQuizStatus: (state) => {
      state.saving = false;
      state.saved = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveQuickQuiz.pending, (state) => {
        state.saving = true;
        state.saved = false;
        state.error = null;
      })
      .addCase(saveQuickQuiz.fulfilled, (state) => {
        state.saving = false;
        state.saved = true;
      })
      .addCase(saveQuickQuiz.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { resetQuickQuizStatus } = quickQuizSlice.actions;
export default quickQuizSlice.reducer;